import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateTimeFr } from "@/lib/format";
import { Clock, Layers, PenLine, Plus, Trash2, Archive, TrendingUp, RefreshCcw } from "lucide-react";
import { HISTORY_ACTION_LABELS } from "@/constants/patrimoine";

const ICONS = {
  create: Plus, update: PenLine, delete: Trash2,
  archived: Archive, value_changed: TrendingUp,
  owner_changed: RefreshCcw, lots_bulk_create: Layers,
};

export default function BuildingHistoryTab({ building }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/patrimoine/history?resource_id=${building.id}&limit=100`)
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, [building.id]);

  return (
    <div className="space-y-4">
      <div>
        <div className="text-overline">Journal</div>
        <h3 className="mt-1 font-heading text-xl">Historique du bâtiment</h3>
      </div>

      {loading && <div className="text-sm text-muted-foreground py-4">Chargement…</div>}
      {!loading && items.length === 0 && (
        <div className="card-elevated p-12 text-center text-muted-foreground">
          <Clock className="mx-auto h-8 w-8 mb-3 text-muted-foreground/60" /> Aucun événement enregistré.
        </div>
      )}

      <ol className="relative border-l-2 border-border ml-3 space-y-4">
        {items.map((ev) => {
          const Icon = ICONS[ev.action] || Clock;
          return (
            <li key={ev.id} data-testid={`history-row-${ev.id}`} className="ml-8 pl-2">
              <span className="absolute -left-[15px] flex h-7 w-7 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <Icon className="h-3.5 w-3.5" />
              </span>
              <div className="card-elevated p-4">
                <div className="flex items-center justify-between">
                  <div className="font-heading text-sm">{HISTORY_ACTION_LABELS[ev.action] || ev.action}</div>
                  <div className="text-xs font-mono text-muted-foreground">{formatDateTimeFr(ev.created_at)}</div>
                </div>
                {ev.changes && Object.keys(ev.changes).length > 0 && (
                  <div className="mt-2 text-xs text-muted-foreground space-y-0.5">
                    {Object.entries(ev.changes).slice(0, 6).map(([k, v]) => (
                      <div key={k}>
                        <span className="font-mono text-foreground">{k}</span> :
                        {typeof v === "object" && v?.from !== undefined
                          ? <span> {formatValue(v.from)} → <strong>{formatValue(v.to)}</strong></span>
                          : <span> {formatValue(v)}</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

function formatValue(v) {
  if (v == null) return "—";
  if (typeof v === "object") return JSON.stringify(v);
  const s = String(v);
  return s.length > 60 ? s.slice(0, 60) + "…" : s;
}
